<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M2.25,18.75C1.009,18.75,0,17.741,0,16.5v-6c0-2.895,2.355-5.25,5.25-5.25h2.379c0.314-0.885,1.162-1.5,2.121-1.5h12
		C22.991,3.75,24,4.759,24,6v7.5c0,0.414-0.336,0.75-0.75,0.75s-0.75-0.336-0.75-0.75V6c0-0.414-0.336-0.75-0.75-0.75h-12
		C9.336,5.25,9,5.586,9,6v6c0,0.414-0.336,0.75-0.75,0.75S7.5,12.414,7.5,12V6.75H6v3.75c0,1.241-1.009,2.25-2.25,2.25H1.5v3.75
		c0,0.414,0.336,0.75,0.75,0.75H3c0.414,0,0.75,0.336,0.75,0.75S3.414,18.75,3,18.75H2.25z M3.75,11.25
		c0.414,0,0.75-0.336,0.75-0.75V6.828c-1.712,0.352-3,1.892-3,3.672v0.75H3.75z"/>
	<path d="M7.5,20.25c-1.654,0-3-1.346-3-3s1.346-3,3-3s3,1.346,3,3S9.154,20.25,7.5,20.25z M7.5,15.75c-0.827,0-1.5,0.673-1.5,1.5
		s0.673,1.5,1.5,1.5S9,18.077,9,17.25S8.327,15.75,7.5,15.75z"/>
	<path d="M19.5,20.25c-1.654,0-3-1.346-3-3s1.346-3,3-3s3,1.346,3,3S21.154,20.25,19.5,20.25z M19.5,15.75
		c-0.827,0-1.5,0.673-1.5,1.5s0.673,1.5,1.5,1.5s1.5-0.673,1.5-1.5S20.327,15.75,19.5,15.75z"/>
	<path d="M12,18.75c-0.414,0-0.75-0.336-0.75-0.75s0.336-0.75,0.75-0.75h3c0.414,0,0.75,0.336,0.75,0.75s-0.336,0.75-0.75,0.75H12z"
		/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'delivery-truck-2',
    },
    name: {
      type: String,
      required: false,
      default: 'DeliveryTruck2',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>